/**
 * Rail-related enumerations.
 * Defines display modes, order types, order sorts, and rail types for content rails.
 */

enum RailDisplayMode {
  ADDON_PHOTO = 'addonPhoto',
  CHANNEL_GUIDE_PHOTO = 'channelGuidePhoto',
  CHARACTER = 'character',
  CLEAN_PHOTO = 'cleanPhoto',
  EPG = 'epg',
  FILTER = 'filter',
  MOSAIC = 'mosaic',
  PHOTO = 'photo',
  POSTER = 'poster',
  PROGRESS_PHOTO = 'progressPhoto',
  RANKING_PHOTO = 'rankingPhoto',
  RANKING_POSTER = 'rankingPoster',
  SQUARE = 'square',
}

enum RailOrderSort {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

enum RailOrderType {
  DATE = 'Fecha',
  RATING = 'Calificacion',
}

enum RailType {
  CHANNEL,
  EPG,
  EVENT,
  FILTER,
  GUIDE_CHANNEL,
  KEEP_WATCHING,
  MOSAIC,
  RECORDING,
  REGULAR,
  RECOMMENDATIONS,
}

export { RailDisplayMode, RailOrderSort, RailOrderType, RailType };
